import "core-js/modules/es6.array.fill";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment, { months } from 'moment';
import waterChainChart from '@/components/biChart/waterChainChart';
import yearRange from '@/components/date/yearRange';
import colControl from '@/components/colControl/colControl';
import waterSameChart from '@comp/biChart/waterSameChart.vue';
export default {
  name: 'chainAnalysis',
  mixins: [GetSiteIdMixin],
  components: {
    waterSameChart: waterSameChart,
    waterChainChart: waterChainChart,
    yearRange: yearRange,
    colControl: colControl
  },
  data: function data() {
    return {
      colOptions: [],
      initNum: 0,
      reportType: '14',
      limitSelectDate: {},
      value: [],
      stime: '',
      etime: '',
      quantum: '',
      dateFormat: 'YYYY-MM-DD',
      chartBoxHeight: '604px',
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      siteId1: ''
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'months'),
      max: moment().endOf('day')
    };
    this.value[0] = this.limitSelectDate.min;
    this.value[1] = this.limitSelectDate.max;
    this.stime = this.limitSelectDate.min.format('YYYY-MM');
    this.etime = this.limitSelectDate.max.format('YYYY-MM');
  },
  props: ['showSiteTree', 'siteId', 'selectType'],
  watch: {
    siteId: {
      handler: function handler(value) {
        if (value) {
          this.siteId1 = value;
        } else {
          this.siteId1 = window.sessionStorage.getItem("siteId");
        }
      },
      deep: true,
      immediate: true
    },
    showSiteTree: {
      handler: function handler(value) {
        if (value === false) {
          this.showSite = false;
        }
      },
      deep: true,
      immediate: true
    },
    currentSiteId: function currentSiteId(value) {}
  },
  computed: {},
  methods: {
    onChange: function onChange() {
      var data = {
        seriesData: [],
        source: []
      };
      var res = {
        result: JSON.parse(JSON.stringify(this.$refs.charts.dataSource))
      };
      var str = this.$refs.colControl.selectCol.join(',');
      var dateTime = ['日期'];
      res.result.records.forEach(function (v, i) {
        dateTime.push(v.dataTime);
        data.seriesData.push({
          type: 'bar'
        });
      });
      var dataList = new Array(res.result.query.factors.length).fill([]);
      res.result.query.factors.forEach(function (item, index) {
        if (str.indexOf(item.code) > -1) {
          dataList[index] = [item.alias || item.title];
          res.result.records.forEach(function (v, i) {
            dataList[index].push(v.factor[item.code].value);
          });
        }
      });
      data.source = [dateTime];
      dataList.forEach(function (v) {
        data.source.push(v);
      });
      this.$refs.charts.changeChartInit(data, 1, res.result.query.factors);
    },
    openCol: function openCol(index) {
      if (typeof index == 'number') {
        this.$refs.colControl[0].visible = true;
      } else {
        this.$refs.colControl.visible = true;
      }
    },
    moment: moment,
    searchChart: function searchChart() {
      this.initNum++;
    },
    dataTypeChange: function dataTypeChange(e) {
      this.reportType = e.target.value;

      if (e.target.value == '14') {
        this.limitSelectDate = {
          min: moment().startOf('day').subtract(1, 'months'),
          max: moment().endOf('day')
        };
        this.value[0] = this.limitSelectDate.min;
        this.value[1] = this.limitSelectDate.max;
        this.stime = this.limitSelectDate.min.format('YYYY-MM');
        this.etime = this.limitSelectDate.max.format('YYYY-MM');
      }
    },
    onYearRangeChange: function onYearRangeChange(value) {
      console.log('季/年区间', value);
      this.stime = value[0] + '';
      this.etime = value[1] + '';
    },
    onMonthRangeChange: function onMonthRangeChange(value) {
      this.value = value;
      this.stime = moment(value[0]).format('YYYY-MM');
      this.etime = moment(value[1]).format('YYYY-MM');
    },
    handleRangeChange: function handleRangeChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1]; // console.log('实时数据/日数据', dateString)
    }
  }
};